export default __webpack_public_path__ + "static/media/fj_bbhfusa.56383603.jpg";